import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';

export type HighBondDriveErrorType =
  | 'FILE_SIZE_EXCEEDED'
  | 'FORBIDDEN_FILE_TYPE'
  | 'GENERIC';

export interface ParsedHighBondDriveError {
  type: HighBondDriveErrorType;
  message?: string;
}

export function parseHighBondDriveError(
  error: unknown,
): ParsedHighBondDriveError {
  if (!error || typeof error !== 'object') {
    return { type: 'GENERIC' };
  }

  const axiosError = error as ExtendedAxiosError;
  const responseData: unknown = axiosError.response?.data;

  if (!responseData) {
    return { type: 'GENERIC' };
  }

  if (typeof responseData === 'string' && responseData.includes('<Error>')) {
    try {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(responseData, 'text/xml');

      const parserError = xmlDoc.querySelector('parsererror'); // cSpell:disable-line
      if (parserError) {
        return { type: 'GENERIC' };
      }

      const errorCode = xmlDoc.querySelector('Code')?.textContent;
      const errorMessage = xmlDoc.querySelector('Message')?.textContent;

      if (
        errorCode === 'EntityTooLarge' ||
        errorMessage?.includes('exceeds the maximum allowed size')
      ) {
        return {
          type: 'FILE_SIZE_EXCEEDED',
          message:
            errorMessage ||
            'Your proposed upload exceeds the maximum allowed size',
        };
      }
    } catch {
      return { type: 'GENERIC' };
    }
  }

  if (typeof responseData === 'object' && responseData !== null) {
    const errorType = (responseData as { type?: string }).type;
    const errorMessage = (responseData as { message?: string }).message;

    if (errorType === 'HighBondDriveForbiddenError') {
      return {
        type: 'FORBIDDEN_FILE_TYPE',
        message: typeof errorMessage === 'string' ? errorMessage : undefined,
      };
    }
  }

  return {
    type: 'GENERIC',
    message:
      typeof responseData === 'object' &&
      responseData !== null &&
      typeof (responseData as { message?: unknown }).message === 'string'
        ? (responseData as { message: string }).message
        : undefined,
  };
}
